import React, { useCallback } from "react";
// import { Text, StyleSheet, View, Button } from "react-native";

// const WebsiteScreen = ({ navigation }) => {
//   return (
//     <>
//       <Text>Website Screen</Text>
//       <Button
//         title="go to youtube"
//         onPress={() => navigation.navigate("")}
//       />
//     </>
//   );
// };

import { Alert, Button, Linking, StyleSheet, View } from "react-native";

const supportedURL = "https://youtube.com/channel/UCjFoV_qcG-8ks0ewJ7F5TmQ";

const unsupportedURL = "https://www.youtube.com/";

const OpenURLButton = ({ url, children }) => {
  const handlePress = useCallback(async () => {
    // Checking if the link is supported for links with custom URL scheme.
    const supported = await Linking.canOpenURL(url);

    if (supported) {
      // Opening the link with some app, if the URL scheme is "http" the web link should be opened
      // by some browser in the mobile
      await Linking.openURL(url);
    } else {
      Alert.alert(`Don't know how to open this URL: ${url}`);
    }
  }, [url]);

  return <Button title={children} onPress={handlePress} />;
};

const YoutubeScreen = () => {
  return (
    <View style={styles.container}>
      <OpenURLButton url={supportedURL}>
        Visit Our Youtube Channel
      </OpenURLButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: "center", alignItems: "center" },
});

export default YoutubeScreen;
